import { jsx as c, jsxs as i } from "react/jsx-runtime";
import { c as d } from "../../../../clsx-OuTLNxxd.js";
import { useState as N } from "react";
import { p as y } from "../../../../main-1j3aFVYE.js";
import { CheckboxContained as C } from "./checkboxcontained.js";
const e = {
  "checkbox-contained-group": "_checkbox-contained-group_1dsxc_29",
  "checkbox-contained-group-header": "_checkbox-contained-group-header_1dsxc_33",
  "checkbox-contained-group-label": "_checkbox-contained-group-label_1dsxc_33",
  "checkbox-contained-group-header-error": "_checkbox-contained-group-header-error_1dsxc_38",
  "checkbox-contained-group-helper": "_checkbox-contained-group-helper_1dsxc_41",
  "checkbox-contained-group-body": "_checkbox-contained-group-body_1dsxc_46",
  "checkbox-contained-group-has-description": "_checkbox-contained-group-has-description_1dsxc_69",
  "checkbox-contained-group-footer": "_checkbox-contained-group-footer_1dsxc_86",
  "checkbox-contained-group-footer-error": "_checkbox-contained-group-footer-error_1dsxc_91"
}, D = {
  withDescription: {
    mobile: 1,
    tablet: 1,
    desktop: 2
  },
  withoutDescription: {
    mobile: 2,
    tablet: 3,
    desktop: 4
  }
}, $ = ({
  labelContent: a,
  helperContent: s,
  error: r,
  buttonWithDescription: p,
  collapsible: n = !1,
  collapsed: u = !0,
  showMore: k,
  showLess: l,
  showLines: h = 2,
  children: x
}) => {
  const [t, _] = N(u), { currentDevice: g } = y(), b = D[p ? "withDescription" : "withoutDescription"][g], m = x.length, f = x.filter((o) => o && o.type === C).filter((o, v) => n && t ? v < b * h : !0).map((o) => /* @__PURE__ */ c(
    "div",
    {
      className: e["checkbox-contained-item"],
      children: o
    },
    `checkbox-item-${o.props.name}___${o.key || o.props.toString}`
  ));
  return /* @__PURE__ */ i("div", { className: e["checkbox-contained-group"], children: [
    /* @__PURE__ */ i("div", { className: e["checkbox-contained-group-header"], children: [
      a && /* @__PURE__ */ c(
        "div",
        {
          className: d(
            e["checkbox-contained-group-label"],
            r && e["checkbox-contained-group-header-error"]
          ),
          children: a
        }
      ),
      s && /* @__PURE__ */ c("div", { className: e["checkbox-contained-group-helper"], children: s })
    ] }),
    /* @__PURE__ */ c(
      "div",
      {
        className: d(
          e["checkbox-contained-group-body"],
          p && e["checkbox-contained-group-has-description"]
        ),
        children: f
      }
    ),
    (n || r) && /* @__PURE__ */ i("div", { className: d(e["checkbox-contained-group-footer"]), children: [
      /* @__PURE__ */ c("div", { className: e["checkbox-contained-group-footer-error"], children: r && /* @__PURE__ */ c("p", { children: r }) }),
      /* @__PURE__ */ c("div", { children: n && m > h * b && /* @__PURE__ */ c("button", { type: "button", onClick: () => _(!t), children: t ? k : l }) })
    ] })
  ] });
};
export {
  $ as CheckboxContainedGroup
};
